import React from 'react'
import styled from 'styled-components'
import { node, bool } from 'prop-types'

import { white } from 'styles/colors'
import { square } from 'styles/global'
import { media, mediaDown } from 'styles/media'
import { fontWeights } from 'styles/typography'
import * as spacing from 'styles/spacing'

import StackedLogo from 'images/logo-stacked.svg'

const Container = styled.div`
  position: relative;
  padding: ${spacing.medium} 48px ${spacing.large};
  background-color: #05294e;
  color: ${white};
  background-image: url('${process.env.BASE_PATH}/images/auth/burst.jpg');
  background-size: cover;
  background-position: center;
  text-align: center;

  ${media.small`
    padding-left: 64px;
    padding-right: 64px;
  `};

  ${media.medium`
    padding-left: 72px;
    padding-right: 72px;
    padding-top: ${spacing.large};
    padding-bottom: ${spacing.xLarge};
  `};

  ${media.large`
    padding-left: 80px;
    padding-right: 80px;
  `};

  ${media.xLarge`
    padding-left: 96px;
    padding-right: 96px;
    padding-top: ${spacing.xLarge};
    padding-bottom: 38px;
  `};

  ${mediaDown.medium`
    margin-top: -${spacing.small};
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  `};
`

const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate3d(-50%, 50%, 0);
  border-radius: 50%;
  background-color: #910b00;
  color: ${white};
  font-size: 20px;
  font-weight: ${fontWeights.medium};
  ${square('32px')};

  ${media.medium`
    font-size: 24px;
    ${square('36px')};
  `};
`

const LogoWrap = styled.div`
  display: flex;
  justify-content: center;

  ${media.medium`
    margin-bottom: -${spacing.small};
  `};

  ${media.xLarge`
    margin-bottom: -6px;
  `};
`

const Logo = styled(StackedLogo)`
  width: 62px;
  height: 50px;
  fill: ${white};

  ${media.medium`
    width: 77px;
    height: 65px;
  `};
`

const SignUpBanner = ({ text, logoOnly }) => (
  <Container>
    {logoOnly ? (
      <LogoWrap>
        <Logo />
      </LogoWrap>
    ) : (
      <div>{text}</div>
    )}

    {!logoOnly && <Info>i</Info>}
  </Container>
)

SignUpBanner.propTypes = {
  text: node.isRequired,
  logoOnly: bool
}

export default SignUpBanner
